import { Directive, inject } from '@angular/core';
import { IS_LOAN_PROCESS } from '../../../process';
import { TemplateAssertDirective } from '../template-assert.directive';

/**
 * @description
 * a structural directive used to assert a template unique to LOAN process. it implements
 * a boolean "isMatch" method to assert the match to the specific product (loan), when a match
 * is made, the template will be rendered, otherwise - no content is rendered
 */

@Directive({
  standalone: true,
  selector: '[isLoanProcess]'
})
export class IsLoanProcessDirective extends TemplateAssertDirective {
  override readonly isMatch$$ = inject(IS_LOAN_PROCESS);
}
